import c from './app-modal.vue';

export default c;
